<script>
    import Service from './Service.svelte'
</script>

<div>
    <h2 class="text-3xl font-semibold text-center mb-24">
        Hvad kan jeg hjælpe med
    </h2>
    <div
        class="
            flex flex-col
            lg:flex-row
            items-center
            lg:space-x-12
            space-y-12
            lg:space-y-0
        "
    >
        <div class="w-full flex-1">
            <Service>
                <svg
                    slot="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-10 w-10 m-2.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        fill-rule="evenodd"
                        d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z"
                        clip-rule="evenodd"
                    />
                </svg>
                <p class="text-xl font-semibold">Frontend Udvikling</p>
            </Service>
        </div>
        <div class="w-full flex-1">
            <Service>
                <svg
                    slot="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-10 w-10 m-2.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"
                    />
                    <path
                        d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"
                    />
                    <path
                        d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"
                    />
                </svg>
                <p class="text-xl font-semibold">Backend Udvikling</p>
            </Service>
        </div>
        <div class="w-full flex-1">
            <Service>
                <svg
                    slot="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    class="h-10 w-10 m-2.5"
                >
                    <path
                        d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                    />
                </svg>
                <p class="text-xl font-semibold">Vejledning</p>
            </Service>
        </div>
    </div>
</div>
  